<script setup>
import {ref, watch} from 'vue'
import {useItemDataStore} from '@/stores/itemData'

const props = defineProps({
    oldValue: Number,
    newValue: Number
})

const itemDataStore = useItemDataStore()

const oldFileName = ref(null)

watch(
    () => props.oldValue,
    async (val) => {
        if (!val) {
            oldFileName.value = null
            return
        }
        const obj = await itemDataStore.get({
            tableName: 'files',
            id: val
        })
        oldFileName.value = obj?.fileName ?? null
    },
    {immediate: true}
)

const newFileName = ref(null)

watch(
    () => props.newValue,
    async (val) => {
        if (!val) {
            newFileName.value = null
            return
        }
        const obj = await itemDataStore.get({
            tableName: 'files',
            id: val
        })
        newFileName.value = obj?.fileName ?? null
    },
    {immediate: true}
)
</script>

<template>
    <div class="d-flex align-items-center">
        <small v-if="oldFileName" class="border rounded py-1 px-2" v-html="oldFileName"></small>
        <i v-else class="small">empty</i>

        <i class="mx-2 bi-chevron-right"/>

        <small v-if="newFileName" class="border rounded py-1 px-2" v-html="newFileName"></small>
        <i v-else class="small">empty</i>
    </div>
</template>